// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventItem {
  width: 100%;
  height: 100%;
  padding: 8px;
}
.EventItem > .time {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}
.EventItem > .title {
  font-size: 14px;
  font-weight: 900;
}

.EventItem.min-height {
  min-height: 16px;
  padding: 4px 8px;
}
.EventItem.min-height > .time {
  font-size: 11px;
  margin-bottom: 2px;
}
.EventItem.min-height > .title {
  width: 118px;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.EventItem.min-height-full {
  padding: 4px 8px;
}
.EventItem.min-height-full > .time {
  font-size: 11px;
  margin-bottom: 2px;
}
.EventItem.min-height-full > .title {
  width: 118px;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.EventItem.min-height-tiny {
  display: flex;
  align-items: center;
  padding: 0 8px;
  min-height: 8px;
}
.EventItem.min-height-tiny > .title-ellipsis {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.EventItem.min-height-tiny > .title-ellipsis::after {
  content: "...";
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  height: 4px;
  margin-top: -10.5px;
}`, "",{"version":3,"sources":["webpack://./src/web/client/src/components/Locations/IndividualLocation/Schedule/Grid/Items/EventItem.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,gBAAA;AADF;AAGE;EACE,eAAA;EACA,kBAAA;AADJ;AAIE;EACE,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFJ;;AAMA;EACE,gBAAA;AAHF;AAKE;EACE,eAAA;EACA,kBAAA;AAHJ;AAME;EACE,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,+BAAA;EACA,2BAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AALF;AAOE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AALJ;AAQE;EACE,cAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,+BAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;AANJ","sourcesContent":[".EventItem {\n  width: 100%;\n  height: 100%;\n  padding: 8px;\n\n  > .time {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-bottom: 4px;\n  }\n\n  > .title {\n    font-size: 14px;\n    font-weight: 900;\n  }\n}\n\n.EventItem.min-height {\n  min-height: 16px;\n  padding: 4px 8px;\n\n  > .time {\n    font-size: 11px;\n    margin-bottom: 2px;\n  }\n\n  > .title {\n    width: 118px;\n    font-size: 11px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.EventItem.min-height-full {\n  padding: 4px 8px;\n\n  > .time {\n    font-size: 11px;\n    margin-bottom: 2px;\n  }\n\n  > .title {\n    width: 118px;\n    font-size: 11px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n  }\n}\n\n.EventItem.min-height-tiny {\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  min-height: 8px;\n\n  > .title-ellipsis {\n    font-size: 16px;\n    font-weight: 700;\n    margin: 0;\n  }\n\n  > .title-ellipsis::after {\n    content: \"...\";\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    height: 4px;\n    margin-top: -10.5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
